import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DIRECT_PLACEMENT_GOALS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

let currentYear = new Date().getFullYear()

const directPlacementGoals = {
  namespaced: true,
  state: buildInitialState({
    directPlacementGoals: [
      { year: currentYear, month: 1, goal: 0 },
      { year: currentYear, month: 2, goal: 0 },
      { year: currentYear, month: 3, goal: 0 },
      { year: currentYear, month: 4, goal: 0 },
      { year: currentYear, month: 5, goal: 0 },
      { year: currentYear, month: 6, goal: 0 },
      { year: currentYear, month: 7, goal: 0 },
      { year: currentYear, month: 8, goal: 0 },
      { year: currentYear, month: 9, goal: 0 },
      { year: currentYear, month: 10, goal: 0 },
      { year: currentYear, month: 11, goal: 0 },
      { year: currentYear, month: 12, goal: 0 }
    ]
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setDirectPlacementGoals: (state, directPlacementGoals) => {
      state.directPlacementGoals = directPlacementGoals
    },
    clearDirectPlacementGoals (state, year = null) {
      if (!year) {
        year = new Date().getFullYear()
      }
      state.directPlacementGoals = [
        { year: year, month: 1, goal: 0 },
        { year: year, month: 2, goal: 0 },
        { year: year, month: 3, goal: 0 },
        { year: year, month: 4, goal: 0 },
        { year: year, month: 5, goal: 0 },
        { year: year, month: 6, goal: 0 },
        { year: year, month: 7, goal: 0 },
        { year: year, month: 8, goal: 0 },
        { year: year, month: 9, goal: 0 },
        { year: year, month: 10, goal: 0 },
        { year: year, month: 11, goal: 0 },
        { year: year, month: 12, goal: 0 }
      ]
    }
  },
  actions: {
    getDirectPlacementGoals: ({ commit, dispatch }, year = new Date().getFullYear()) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting direct placement goals, please wait...' })

      return api.doGet({ path: PATH_DIRECT_PLACEMENT_GOALS, parameters: { Year: year } })
        .then(json => json.data)
        .then(directPlacementGoals => {
          commit('updateStatus', { status: COMPLETE })
          if (directPlacementGoals.length > 0) {
            commit('setDirectPlacementGoals', directPlacementGoals)
          } else {
            commit('clearDirectPlacementGoals', year)
          }
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          commit('clearDirectPlacementGoals', year)
          notifyError(dispatch, 'Unable to select direct placement goals')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveDirectPlacementGoals: ({ commit, dispatch }, directPlacementGoals) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving direct placement goals, please wait...' })

      return api.doPost({ path: PATH_DIRECT_PLACEMENT_GOALS, data: directPlacementGoals })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save direct placement goals.')
          }

          notifySuccess(dispatch, 'Direct placement goals saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save direct placement goals')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default directPlacementGoals
